export const linkcont = [
    { 
        id: 1, 
        title: "our services", 
        src: "/images/service.svg",
        href: "/#review-section" 
    },
    { 
        id: 2,
        title: "how it works", 
        src: "/images/how-it-works.svg",
        href: "/#how-it-works" 
    },
    { 
        id: 3, 
        title: "reviews", 
        src: "/images/reviews.svg" ,
        href: "/#why-git-global" 
    },
  
]